import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { RecordCard } from './record-card';

@JsonObject('model.time_card.TimeCard')
export class DayCard extends AbstractModel {

    @JsonProperty(Number, 'id')
    id?: number;

    @JsonProperty(DateConverter, 'date')
    date?: Date;

    @JsonProperty([RecordCard], 'records')
    records?: RecordCard[];

}